
import { canv } from '@/canv/global.js'
import { drawRoundedRect, isOverRect} from '@/canv/utils.js'
import { textWidget } from '@/elements/text/text.js'



export class cardWidgetSlider {

    constructor(startX, startY, width) {
        this.height = 25;

        this.textPart = new textWidget(0, 0);

        this.textPart.menuTextSize(18, true);

        this.updateDims(startX, startY, width);
    }


    updateDims(startX, startY, width) {
        this.startX = startX;
        this.startY = startY;
        this.width = width;
        this.sliderWidth = this.width - 68; // 65 подобрано, чтобы вмещалась число процентов (100)
        this.updateTextPosition();
    }

    updateTextPosition() {
        this.textPart.startX = this.startX + this.width - this.textPart.width;
        this.textPart.startY = this.startY + this.height/2 - this.textPart.height/2 + this.textPart.lines[0].textHeight;
        this.textPart.updateDims();
    }

    setProgressData(progressData, smooth = false) {

        if (smooth && this.progressData != null) { // при создании виджета и первом вызове setProgressData,  this.progressData == null
            this.transitionProgress = this.progressData["currentProgress"];
        }

        this.progressData = progressData;
        
        this.textPart.setText(Math.round(this.progressData["currentProgress"] * 100) + "%");
        this.textPart.menuTextColor(this.progressData["majorColor"], true, false);
        this.updateTextPosition();
    }

    // draw

    draw(drawCatcher, isInteractionSlider) {

        if (!drawCatcher) this.drawRatio = 0;

        let sliderHeight = 4;

        if (isInteractionSlider) {
            sliderHeight = 8;
        }

        // slider background
        drawRoundedRect(this.startX, this.startY + this.height/2 - sliderHeight/2, this.sliderWidth, sliderHeight, sliderHeight * 10);
        canv.ctx.fillStyle = "#D9D9D9";
        canv.ctx.fill();

        let drawProgress = this.progressData["currentProgress"];

        // slider filler
        if (this.transitionProgress != -1) {
            canv.redraw();
            drawProgress = this.transitionProgress;
            if (this.transitionProgress <= this.progressData["currentProgress"]) {
                this.transitionProgress += 0.03;
                if (this.transitionProgress >= this.progressData["currentProgress"]) {
                    this.transitionProgress = -1;
                }
            } else {
                this.transitionProgress -= 0.03;
                if (this.transitionProgress <= this.progressData["currentProgress"]) {
                    this.transitionProgress = -1;
                }
            }
            
        }

        drawRoundedRect(this.startX, this.startY + this.height/2 - sliderHeight/2, drawProgress * this.sliderWidth, sliderHeight, sliderHeight * 10);

        canv.ctx.fillStyle = this.progressData["majorColor"];
        canv.ctx.fill();

        this.textPart.draw();

        if (drawCatcher) {
            this.drawCatcher(drawProgress, isInteractionSlider);
        }
    }

    drawCatcher(drawProgress, isInteractionSlider) {

        let size = this.sliderCatcherSize;
        let currentWidth =  size * this.drawRatio;
        let currentHeight =  size * this.drawRatio;

        let catcherCenterX = this.startX + drawProgress * this.sliderWidth;
        let catcherCenterY = this.startY + this.height/2;

        let modifiedStartX = catcherCenterX - currentWidth/2;
        let modifiedStartY = catcherCenterY - currentHeight/2;

        
        drawRoundedRect(modifiedStartX, modifiedStartY, currentWidth, currentHeight, 10 * currentWidth);

        if (this.drawRatio < 1) {
            this.drawRatio += 0.05;
            canv.redraw();
        }

        canv.ctx.strokeStyle = "#0B99FF";
        canv.ctx.fillStyle = "#FFFFFF";
        if (isOverRect(modifiedStartX, modifiedStartY, currentWidth, currentHeight) || isInteractionSlider) {
            canv.ctx.fillStyle = "#0B99FF";
        }
        canv.ctx.lineWidth = 5;
        canv.ctx.stroke();
        canv.ctx.fill();
    }



    // helpers

    calculateProgress() {
        var pt = canv.actionManager.getActionPoint();
        var x = pt.x;

        let result = 0;

        if (x < this.startX) {
            result = 0;
        } else if (x > this.startX + this.sliderWidth) {
            result = 1;
        } else {
            let newProgress = (x - this.startX) / this.sliderWidth;
            result = newProgress;
        }

        return result;
    }

    isOverSliderCatcher() {
        let catcherCenterX = this.startX + this.progressData["currentProgress"] * this.sliderWidth;
        let catcherCenterY = this.startY + this.height/2;
        
        return isOverRect(catcherCenterX - this.sliderCatcherSize/2, catcherCenterY - this.sliderCatcherSize/2, this.sliderCatcherSize, this.sliderCatcherSize);
    }




    startX = 0;
    startY = 0;
    width = 0;
    height = 0;
    sliderWidth = 0;

    textPart = null;

    transitionProgress = -1;

    drawRatio = 0;


    // constants
    progressData = null;
    sliderCatcherSize = 25;

}











